import { render } from "./CompactCollegeStats.vue?vue&type=template&id=4de59e37&scoped=true"
import script from "./CompactCollegeStats.vue?vue&type=script&lang=js"
export * from "./CompactCollegeStats.vue?vue&type=script&lang=js"

import "./CompactCollegeStats.vue?vue&type=style&index=0&id=4de59e37&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de59e37"]])

export default __exports__